var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNobrandMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 50,
    viewBox: "0 0 33 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.375 50H5.625C4.72583 50 4 49.33 4 48.5C4 47.67 4.72583 47 5.625 47H28.375C29.2742 47 30 47.67 30 48.5C30 49.33 29.2742 50 28.375 50Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2.05153C8.49174 2.05153 2 8.33844 2 16.094C2 16.094 2 16.094 2 16.1198C2 16.8155 2.05321 17.5111 2.15963 18.1811C2.4789 20.2681 3.27706 22.2006 4.4211 23.8753C4.9266 24.5968 5.48532 25.2667 6.12385 25.8851L9.31651 29.6727L9.60917 30.0334L17.1119 39L23.7101 30.1623V30.0334H23.8165L26.9826 25.782C27.9138 24.8287 28.7119 23.7723 29.3505 22.587C30.2018 20.9896 30.7605 19.2375 30.9468 17.3565C31 16.9443 31 16.5063 31 16.0682C31 16.0682 31 16.0682 31 16.0425C31 8.28691 24.5083 2 16.5 2V2.05153Z",
    stroke: "#0A0A0A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.5C19.5 16.1517 18.1517 17.5 16.5 17.5C14.8483 17.5 13.5 16.1517 13.5 14.5C13.5 12.8483 14.8483 11.5 16.5 11.5C18.1517 11.5 19.5 12.8483 19.5 14.5Z",
    stroke: "#0A0A0A",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNobrandMap);
export default __webpack_public_path__ + "static/media/icon_nobrand_map.fff46fb32e56de66dd8d07650e27262a.svg";
export { ForwardRef as ReactComponent };